<template>
    <div :class="getRowClass()">
        <slot name="body"/>
    </div>
</template>

<script>
  export default {
    name: 'LayoutWrapper',
    props: {
      className: {
        type: String,
        default: ''
      },
      length: {
        type: Number,
        default: 1
      },
      print: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getRowClass: function () {
        let className = this.className + ' '

        if (this.print === true) {
          if (this.length === 1) {
            className += 'col-sm-12'
          } else if (this.length === 2) {
            className += 'col-sm-6'
          } else if (this.length === 3) {
            className += 'col-sm-4'
          } else if (this.length >= 4) {
            className += 'col-sm-3'
          }
        } else {
          if (this.length === 1) {
            className += 'col-lg-12 col-md-12 col-sm-12'
          } else if (this.length === 2) {
            className += 'col-lg-6 col-md-6 col-sm-6'
          } else if (this.length === 3) {
            className += 'col-lg-4 col-md-6 col-sm-6'
          } else if (this.length >= 4) {
            className += 'col-lg-3 col-md-6 col-sm-6'
          }
        }

        return className
      }
    }
  }
</script>